module.exports = __webpack_public_path__ + "img/Atelier_2.c576ce89.jpg";